import './WriteOperationsTopBar.scss';
import React, { memo } from 'react';
import { Button, Icons } from 'plume-ui';
import FormattedMessage from '../../../../utils/components/FormattedMessage';
import {
  AdjustableComponent,
  useClasses,
} from '../../../../utils/hooks/useClasses';

type WriteOperationsTopBarProps = {
  onBackClick?: () => void;
  onSubmit?: () => void;
  isSubmitDisabled: boolean;
  isLoading?: boolean;
  submitting: boolean;
};

type WriteOperationsTopStyles = {
  root: string;
  backButton: string;
};

const WriteOperationsTopBar: AdjustableComponent<
  WriteOperationsTopBarProps,
  WriteOperationsTopStyles
> = ({
  onBackClick,
  onSubmit,
  isSubmitDisabled = true,
  isLoading = false,
  classes,
  submitting,
}) => {
  const styles = useClasses(
    {
      root: 'WriteOperationsTopBar',
      backButton: 'WriteOperationsTopBar__back-button',
    },
    classes,
  );
  const finishButtonCopyId = isLoading ? 'finishing' : 'finish';

  return (
    <div className={styles.root}>
      {onBackClick && (
        <Button
          styleVariant="tertiary-grey"
          selected
          type="button"
          classes={(current) => ({
            ...current,
            root: `${current.root} ${styles.backButton}`,
          })}
          icon={<Icons.ArrowLeftIcon />}
          onClick={() => onBackClick()}
        >
          <FormattedMessage id="back" />
        </Button>
      )}
      {onSubmit && (
        <Button
          styleVariant="superprimary"
          disabled={isSubmitDisabled || isLoading || submitting}
          type="submit"
          onClick={() => {
            if (!submitting) onSubmit();
          }}
        >
          <FormattedMessage id={finishButtonCopyId} />
        </Button>
      )}
    </div>
  );
};

export default memo(WriteOperationsTopBar);
